<form #formWso2 method='post' action='https://www.monex.com.mx/api/iam/authenticationendpoint/bancav2/autentica.jsp' hidden="hidden">
  <input type='hidden' name='MONEX.lerror' value='{{this.ERROR_URL}}' />
  <input type='hidden' name='SAML2.IdPURL' value='{{this.SAML2}}' />
  <input type='hidden' name='j_username' value='{{this.usernameWso2}}' />
  <input type='hidden' name='j_password' value='{{this.passwordWso2}}' />
  <input type='hidden' name='SAMLRequest' value='{{this.samlRequest}}' />
</form>
